<template>
    <m-main-layout>
        <div class="margin-bottom">
            <add-button @click.native="add" v-if="dataList.length > 0"></add-button>
        </div>
        <div class="page-content-main">
            <el-table :data="dataList" default-expand-all style="width: 100%" row-key="id"
                      :tree-props="{children: 'child'}" :indent="30" v-if="dataList.length > 0">
                <el-table-column
                    prop="name"
                    label="名称">
                </el-table-column>
                <el-table-column
                    prop="state"
                    label="状态" width="250">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.state === 1 ? 'success' : 'danger'" disable-transitions>
                            {{ scope.row.state === 0 ? '禁用' : '可用' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="sort"
                    label="排序">
                </el-table-column>
                <el-table-column
                    prop="create_time"
                    label="创建时间"></el-table-column>
                <el-table-column
                    prop="update_time"
                    label="修改时间"></el-table-column>
                <el-table-column>
                    <div slot-scope="scope" style="text-align: right;">
                        <edit-button @click.native="edit(scope.row)" :rule="'/type/'+formData.akey+'/edit'"></edit-button>
                        <del-button @click.native="del(scope.row.id)" :rule="'/type/'+formData.akey+'/del'"></del-button>
                    </div>
                </el-table-column>
            </el-table>
            <div class="text-center null-data f14 info" v-else>
                暂无数据，<add-button slot="right-btn" @click.native="add" :rule="'/type/'+formData.akey+'/add'"
            ></add-button>
            </div>
            <div class="text-center padding-top-bottom-20" v-if="dataList.length > 0">
                <el-pagination
                    background
                    layout="total,prev, pager, next"
                    :page-size="pageSize"
                    :current-page.sync="page"
                    :total="totalCount"
                    @current-change="pageChange">
                </el-pagination>
            </div>
        </div>
    </m-main-layout>
</template>

<script>
export default {
    name: "MemberList",
    data() {
        return {
            dataList: [],
            totalPage: 0,
            totalCount: 0,
            searchForm: {
                pageSize:15,
                page:1,
            },
            formData:{
                name:''
            },
            path:'',
            listData:null
        }
    },
    created() {
        let _config = window.config.paths();
        this.path = this.$route.path;
        this.params = _config[this.path];

        this.listData = this.params.listData ? this.params.listData : {};

        this.searchForm = this.$route.query ? {...this.searchForm,...this.$route.query} : {...this.searchForm};
        this.searchForm.page = parseInt(this.searchForm.page);
        this.searchForm.pageSize = parseInt(this.searchForm.pageSize);
    },
    methods: {
        getList() {
            let _this = this;
            this.dataList = [];
            this.$http.httpPost({
                url: '/Type/listPage',
                datas: {akey:this.type,page: this.page, pageSize: this.pageSize, orderBy: 'sort', sortBy: 'asc'},
                success: (res) => {
                    _this.dataList = res.list;
                    _this.totalPage = res.totalPage;
                    _this.totalCount = res.totalCount;
                }
            });
        },
        add(){
            let _this = this;
            this.$prompt('请输入名称', '添加', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(({ value }) => {
                _this.formData.name = value;

                _this.$http.httpPost({
                    url: '/Type/add',
                    datas: this.formData,
                    success: (res) => {
                        console.log(res);
                        _this.getList();
                    }
                });
            }).catch(() => {

            });
        },
        del(id) {
            var _this = this;
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                _this.$http.httpPost({
                    url: '/Type/del',
                    datas: {id: id,akey:this.formData.akey},
                    success: (res) => {
                        _this.getList();
                    }
                });
            }).catch(() => {
            });
        },
        edit(item){
            let _this = this;
            this.$prompt('请输入名称', '编辑', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue:item.name
            }).then(({ value }) => {
                _this.formData.name = value;

                _this.$http.httpPost({
                    url: '/Type/edit',
                    datas: {...this.formData,id:item.id},
                    success: (res) => {
                        console.log(res);
                        _this.getList();
                    }
                });
            }).catch(() => {

            });
        },
        pageChange(page) {
            this.page = page;
            this.getList();
        },
    },
    mounted() {
        this.getList();
    }
}
</script>
